var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-rating",class:'rating-' + _vm.rating},_vm._l((5),function(rating){return _c('div',{staticClass:"rating",class:{'editable': _vm.editable},on:{"click":function($event){return _vm.$emit('clicked', rating)}}},[_c('font-awesome-icon',{attrs:{"icon":"star"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }